import { Input, Space, Checkbox, Col, Row, Tooltip } from 'antd';
import React, { useState, useRef, useEffect } from 'react';
import { ReactComponent as IconAdd } from '@/images/icons/edm/template-group-add.svg';
import { ReactComponent as IconManage } from '@/images/icons/edm/template-group-manage.svg';
import { ReactComponent as IconWarn } from '@/images/icons/edm/icon_warning-red.svg';
import classes from './multiSelectContent.module.scss';
import classname from 'classnames';
import { getIn18Text } from 'api';
const MultiSelectContent = ({ dataList, selectedIds, onCheckedChange, createItems, manageItems, addItems, addCancel, errorMessage, createGroupId, hideCheckbox, permisson = true, maxLength = 12, typePinyin = 'FENZU', }) => {
    const [totalList, setTotalList] = useState([]);
    const [addName, setAddName] = useState('');
    const inputRef = useRef(null);
    const onNameChange = (event) => {
        setAddName(event.target.value || '');
    };
    const beforeAddItems = () => {
        addItems(addName);
        setAddName('');
    };
    useEffect(() => {
        setTotalList(dataList);
        setTimeout(() => {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
    }, [dataList]);
    return (React.createElement("div", { className: classname(classes.group, hideCheckbox ? classes.groupHide : {}) },
        React.createElement(Checkbox.Group, { onChange: onCheckedChange, value: selectedIds },
            React.createElement(Row, { className: classes.items }, totalList.length <= 0 ? (React.createElement("div", { className: classes.empty },
                getIn18Text(`ZANWU${typePinyin}`),
                permisson && (React.createElement(React.Fragment, null,
                    ",\u00A0",
                    React.createElement("span", { className: classes.create, onClick: createItems }, getIn18Text('LIJIXINZENG')))))) : (totalList.map(item => {
                return (React.createElement(Col, { key: item.id, span: 24 }, item.id !== createGroupId ? (React.createElement("div", { className: classes.item },
                    React.createElement(Checkbox, { key: item.id, value: item.id, style: { display: 'block', margin: '0' }, disabled: selectedIds.length === 10 && !selectedIds.includes(item.id) },
                        React.createElement(Tooltip, { title: item.name.length > 10 ? item.name : '' }, item.name)))) : (React.createElement(Input.Group, { compact: true },
                    React.createElement("div", { onClick: e => e.stopPropagation() },
                        React.createElement(Input, { style: { width: '100%' }, ref: inputRef, placeholder: getIn18Text(`QINGSHURU${typePinyin}MINGCHENG`), value: addName, maxLength: maxLength, onChange: onNameChange, suffix: React.createElement(React.Fragment, null,
                                React.createElement("span", { className: classes.inputBtn, style: { marginRight: '12px' }, onClick: () => beforeAddItems() }, getIn18Text('QUEDING')),
                                React.createElement("span", { className: classes.inputBtn, onClick: addCancel }, getIn18Text('QUXIAO'))) }))))));
            })))),
        permisson && (React.createElement(Space, { className: classes.footer },
            React.createElement("span", { className: classes.btns, onClick: createItems },
                React.createElement(IconAdd, { className: classes.svg }),
                getIn18Text(`XINZENG${typePinyin}`)),
            React.createElement("span", { className: classes.btns, style: { color: totalList.filter(item => item.id !== createGroupId).length === 0 ? '#C0C8D6' : '#232D47' }, onClick: () => {
                    totalList.filter(item => item.id !== createGroupId).length > 0 && manageItems();
                } },
                React.createElement(IconManage, { className: classes.svg }),
                getIn18Text(`GUANLI${typePinyin}`)))),
        React.createElement("div", { className: classes.err }, errorMessage && (React.createElement("div", { className: classes.errText },
            React.createElement(IconWarn, { style: { marginRight: '4px' } }),
            " ",
            errorMessage)))));
};
export default MultiSelectContent;
